import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Storage from '@material-ui/icons/Storage'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import pricingPageStyle from 'assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx'
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx'
import ConsumerRequestsTable from 'views/Tables/ConsumerRequestsTable'
import translation from '../../translation/translate'
import style from "assets/css/style.jsx"

const styles = require(`../../assets/css/style.jsx`).default;

const client = process.env.REACT_APP_CLIENT

class ConsumerRequestPage extends React.Component {
  render() {
    const { classes } = this.props

    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={12} md={6}>
              <h1 style={styles.titleWhite}>{translation[client].list_title}</h1>
            </GridItem>
          </GridContainer>
          <GridContainer justify='center'>
            <GridItem xs={12}>
              <Card>
                <CardHeader color='info' icon>
                  <CardIcon color='info'>
                    <Storage />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>Liste de mes demandes</h4>
                </CardHeader>
                <CardBody>
                  <ConsumerRequestsTable classes={classes} />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

ConsumerRequestPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles({...style, ...pricingPageStyle, ...extendedTablesStyle})(ConsumerRequestPage)



// WEBPACK FOOTER //
// ./src/views/Pages/ConsumerRequestPage.jsx